/**
 * Homepage band links from the main menu: `/#plans`, `/#sets`, `/#shop_all`.
 *
 * Shopify section wrappers are `shopify-section-template--…__plans`, so a bare `#plans`
 * does not scroll by itself unless the section also exposes that short id. This script:
 *  1. On click of a matching menu link while the target is on the page — preventDefault,
 *     set the hash, scroll (same-page clicks otherwise look like a no-op).
 *  2. On load / hashchange / pageshow — scroll if the hash is one of ours.
 *
 * Injected into layout/theme.liquid by theme/apply-brand.mjs.
 */
;(function () {
  var KEYS = { plans: true, sets: true, shop_all: true }

  function keyFromHash(hash) {
    var key = (hash || '').replace(/^#/, '')
    return KEYS[key] ? key : null
  }

  function sectionFor(key) {
    return (
      document.getElementById(key) ||
      document.querySelector('[id$="__' + key + '"]')
    )
  }

  function preferReduce() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    )
  }

  function scrollToKey(key) {
    var el = sectionFor(key)
    if (!el) return false
    el.scrollIntoView({
      behavior: preferReduce() ? 'auto' : 'smooth',
      block: 'start',
    })
    return true
  }

  function goFromLocation() {
    var key = keyFromHash(location.hash)
    if (!key) return
    // Layout (sticky header, fonts) can shift the target after the first paint.
    if (!scrollToKey(key)) return
    requestAnimationFrame(function () {
      scrollToKey(key)
    })
  }

  function hashFromHref(href) {
    if (!href) return null
    // `/#plans`, `#plans`, `https://host/#plans`, `https://host/?x=1#plans`
    var i = href.lastIndexOf('#')
    if (i === -1) return null
    return keyFromHash(href.slice(i))
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return
      if (event.button !== 0) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
      var a = event.target.closest && event.target.closest('a[href]')
      if (!a) return
      var key = hashFromHref(a.getAttribute('href'))
      if (!key) return
      // Target is on this page (homepage): scroll here. Elsewhere, let the browser
      // navigate to `/#plans` and goFromLocation will run after load.
      if (!sectionFor(key)) return
      event.preventDefault()
      if (location.hash !== '#' + key) {
        history.pushState(null, '', '#' + key)
      }
      scrollToKey(key)
    },
    false,
  )

  window.addEventListener('popstate', goFromLocation)
  window.addEventListener('hashchange', goFromLocation)
  window.addEventListener('pageshow', goFromLocation)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', goFromLocation)
  } else {
    goFromLocation()
  }
})()
